// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dialog from "../../components/Dialog/Dialog.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as InputToggle from "../../components/InputToggle/InputToggle.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as NotificationHooks from "../../backend/NotificationHooks.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import NotificationDialogModuleCss from "./NotificationDialog.module.css";

let classes = NotificationDialogModuleCss;

function NotificationDialog(props) {
  let onUpdateSubscription = props.onUpdateSubscription;
  let onDismiss = props.onDismiss;
  let currentUserNotificationSubscription = props.currentUserNotificationSubscription;
  let sendTestNotification = NotificationHooks.useDispatchTestNotification(props.currentUserUid, props.place);
  let permission = window.Notification.permission;
  return <Dialog.make
    className={classes.notificationDialog}
    visible={true}
  >
    <header>
      <h3>
        {`Nastavení notifikací`}
      </h3>
      <p>
        {`Přihlaš se k odběru důležitých zpráv.`}
      </p>
    </header>
    {permission === "denied" ? <p
        className={Styles.messageBar.variantDanger}
      >
        {`Notifikace pro tuto aplikaci jsou zakázané, musíš je povolit v nastavení prohlížeče nebo systému.`}
      </p> : <>
        {(
          permission === "granted" ? null : <p
              className={Styles.messageBar.base}
            >
              {`Jakmile zapneš notifikace, bude to po tobě chtít ještě odsouhlasit povolení pro tuto aplikaci. Bez povolení notifikace nefungují.`}
            </p>
        )}
        <form>
          <fieldset
            className={`reset ` + Styles.fieldset.grid}
          >
            <InputWrapper.make
              inputName={"free_table"}
              inputSlot={<InputToggle.make
                checked={(currentUserNotificationSubscription & 1) !== 0}
                onChange={event => {
                  let target = event.target;
                  let checked = target.checked;
                  onUpdateSubscription(checked ? currentUserNotificationSubscription | 1 : currentUserNotificationSubscription & -2);
                }}
              />}
              labelSlot={"První pivo"}
            />
            <InputWrapper.make
              inputName={"fresh_keg"}
              inputSlot={<InputToggle.make
                checked={(currentUserNotificationSubscription & 2) !== 0}
                onChange={event => {
                  let target = event.target;
                  let checked = target.checked;
                  onUpdateSubscription(checked ? currentUserNotificationSubscription | 2 : currentUserNotificationSubscription & -3);
                }}
              />}
              labelSlot={"Čerstvý sud"}
            />
          </fieldset>
        </form>
      </>}
    {import.meta.env.PROD ? null : <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => sendTestNotification()}
      >
        {"Send test notification"}
      </button>}
    <footer>
      <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => onDismiss()}
      >
        {"Zavřít"}
      </button>
    </footer>
  </Dialog.make>;
}

let make = NotificationDialog;

export {
  classes,
  make,
}
/* classes Not a pure module */
